import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import './styles/index.scss';
import './i18n';
import { languages, getBestMatchLanguage } from './i18n';
import { useTranslation } from 'react-i18next';

// Компоненти
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import GoogleTagManager from './components/GoogleTagManager';

// Лінивий імпорт сторінок
const NewsPage = React.lazy(() => import('./pages/NewsPage'));
const NewsDetailPage = React.lazy(() => import('./pages/NewsDetailPage'));
const VideosPage = React.lazy(() => import('./pages/VideosPage'));
const CorporatePage = React.lazy(() => import('./pages/CorporatePage'));
const NGOPage = React.lazy(() => import('./pages/NGOPage'));
const WebinarRegisterPage = React.lazy(() => import('./pages/WebinarRegisterPage'));
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const RegisterPage = React.lazy(() => import('./pages/RegisterPage'));
const ProfilePage = React.lazy(() => import('./pages/ProfilePage'));
const NotFoundPage = React.lazy(() => import('./pages/NotFoundPage'));

// Компонент для перенаправлення на мовну версію
const LanguageRedirect = () => {
  // Визначаємо найкращу мову для користувача
  const targetLang = getBestMatchLanguage();
  return <Navigate to={`/${targetLang}`} replace />;
};

// Обгортка для мовних маршрутів
const LanguageWrapper = () => {
  const { language } = useParams();
  const { i18n } = useTranslation();
  
  useEffect(() => {
    if (languages.includes(language) && i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);
  
  // Якщо мовний параметр не є допустимим, перенаправляємо на визначену найкращу мову
  if (!languages.includes(language)) {
    const bestLang = getBestMatchLanguage();
    return <Navigate to={`/${bestLang}`} replace />;
  }
  
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<NewsDetailPage />} />
        <Route path="/videos" element={<VideosPage />} />
        <Route path="/corporate" element={<CorporatePage />} />
        <Route path="/ngo" element={<NGOPage />} />
        <Route path="/webinars" element={<WebinarRegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <Router>
      <GoogleTagManager />
      <Suspense fallback={<div className="loading">Loading...</div>}>
        <Routes>
          {/* Перенаправлення з кореневого URL на правильну мовну версію */}
          <Route path="/" element={<LanguageRedirect />} />
          
          {/* Маршрути для кожної мовної версії */}
          <Route path="/:language/*" element={<LanguageWrapper />} />
          
          {/* Обробка невідомих шляхів */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App; 